/**
 * Byte-aware push batches for the web records backend — the twin of the
 * desktop's `sync/push_budget.rs`. A batch is a PREFIX of the unsent ops
 * (order kept) that stops at `maxOps`, or before the op that would take the
 * batch over `maxBytes` of encoded `fields`. It always holds at least one op,
 * and an op over the per-op cap travels ALONE: if the server refuses it, only
 * that op is dropped, never the good ones that happened to share its batch.
 */
import {
  OUTBOX_ITEM_MAX_BYTES,
  PUSH_BATCH_MAX_BYTES,
  PUSH_OP_OVERHEAD_BYTES,
} from '../syncLimits';

const encoder = new TextEncoder();

export function opBytes(op) {
  return encoder.encode(JSON.stringify(op?.fields ?? {})).length;
}

export function takePushBatch(unsent, maxOps, maxBytes = PUSH_BATCH_MAX_BYTES) {
  const batch = [];
  let total = 0;
  for (const op of unsent) {
    if (batch.length >= maxOps) break;
    const bytes = opBytes(op);
    const oversize = bytes > OUTBOX_ITEM_MAX_BYTES;
    const cost = bytes + PUSH_OP_OVERHEAD_BYTES;
    if (batch.length && (oversize || total + cost > maxBytes)) break;
    batch.push(op);
    total += cost;
    if (oversize) break;
  }
  return batch;
}
